module.exports = __webpack_public_path__ + "img/vietnam_sniper.355004d4.webp";